import { render, staticRenderFns } from "./ValidateVatNumber.vue?vue&type=template&id=029a6bb9&scoped=true"
import script from "./ValidateVatNumber.vue?vue&type=script&lang=js"
export * from "./ValidateVatNumber.vue?vue&type=script&lang=js"
import style0 from "./ValidateVatNumber.vue?vue&type=style&index=0&id=029a6bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a6bb9",
  null
  
)

export default component.exports